import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseDiscountUpdatedTemplates = [
  {
    id: '-214001',
    language: Language.EN,
    subject: 'Lease discount update',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>A discount has been updated on your lease.</p>
          <p>More details here : {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-214002',
    language: Language.FR,
    subject: 'Modification de remise sur le bail',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Une remise relative à votre bail a été mise à jour.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-214003',
    language: Language.NL,
    subject: 'Update op korting',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Een korting is bijgewerkt op uw huurovereenkomst.</p>
          <p>Meer details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-214004',
    language: Language.DE,
    subject: 'Mietrabatt-Update',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ein Rabatt in Ihrem Mietvertrag wurde aktualisiert.</p>
          <p>Weitere Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
